/**
 * Time on card (v1 ticket 43): how long a card was on screen before its first answer, sent with that answer as `ms`
 * so the owner's card health can show a median. A view marks the card on screen (`cardShown`, idempotent) and its
 * answer save takes the time once (`cardMs`); a retry, a Show me after a miss or a second answer to the same card
 * carries none. Nothing is stored.
 */
export const CARD_MS_MAX = 600_000;

const shown = new Map<string, number | 'taken'>();
const keyOf = (momentId: string, taskId: string) => `${momentId}\u0000${taskId}`;

/** The card is on screen now (first call per card counts). */
export function cardShown(momentId: string, taskId: string, now = Date.now()) {
  const k = keyOf(momentId, taskId);
  if (!shown.has(k)) shown.set(k, now);
}

/** `{ms}` for the card's first answer (capped), else nothing. */
export function cardMs(momentId: string, taskId: string, now = Date.now()): { ms?: number } {
  const k = keyOf(momentId, taskId);
  const at = shown.get(k);
  shown.set(k, 'taken');
  if (typeof at !== 'number') return {};
  return { ms: Math.min(CARD_MS_MAX, Math.max(0, Math.round(now - at))) };
}
